/*
 * @Author: ken yang
 * @Date: 2022-08-30 11:14:14
 * @LastEditTime: 2022-09-20 12:01:14
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_pc/src/store/language.js
 */
import { defineStore } from 'pinia'

const ACCOUNT_TYPES = [1, 2, 5]
const accountInfoRequestMap = new Map()

const normalizeAccountTypes = (types = ACCOUNT_TYPES) => {
  const list = Array.isArray(types) ? types : [types]
  return [...new Set(list.map(type => Number(type)).filter(type => Number.isFinite(type)))]
}

const requestAccountInfo = async (type) => {
  if (accountInfoRequestMap.has(type)) return accountInfoRequestMap.get(type)

  const request = userApi.accountInfo({ type }).finally(() => {
    accountInfoRequestMap.delete(type)
  })
  accountInfoRequestMap.set(type, request)
  return request
}

const useUserStore = defineStore('userStore', {
  state: () => {
    const winToken = getUrlQuery().token
    return {
      token: winToken || sessionStorage.token || localStorage.token || '',
      accountInfo: {},
      info: {},
      usdtAsset: 0, // 资金账户的 USDT 资产
    }
  },
  getters: {
  },
  actions: {
    async getInfo () {
      const info = await userApi.info({})

      this.$patch(state => {
        state.info = info
      })
    },
    async getAccountInfo (types = ACCOUNT_TYPES) {
      const entries = await Promise.all(
        normalizeAccountTypes(types).map(async type => [type, await requestAccountInfo(type)])
      )
      const accountInfo = entries.reduce((obj, [type, data]) => {
        obj[type] = data
        return obj
      }, {})

      this.$patch(state => {
        state.accountInfo = {
          ...state.accountInfo,
          ...accountInfo,
        }
      })
      return this.accountInfo
    },
    async logout () {
      this.token = ''
      this.accountInfo = {}
      this.info = {}
      const pathname = window.location.pathname
      const path = pathname.substring(1)
      winMes.postParent('toLogin', { redirect: path })
    }
  },
  init () {
    if (this.token) {
      this.getInfo()
      this.getAccountInfo()
    }
    this.$subscribe((mutation, state) => {
      localStorage.token = state.token
    })

    window.addEventListener('storage', (obj) => {
      if (obj.key === 'token') {
        this.$patch(state => {
          state.token = obj.newValue
        })
      }
    })
  },
})

export default useUserStore
